export default "/images/9a7a9ade6dc7c05c6abc93fd82d8804a.avif";